import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface UserFeedbackClosedProps extends EventProps {
    feedbackId?: string
    bundleId?: string
}

/**
 * @event user_feedback_closed
 * @description Emitted when the user closes the feedback dialog.
 */
export const UserFeedbackClosedAnalytics = createAnalyticsStatic<UserFeedbackClosedProps>(
    ANALYTICS_EVENTS.USER_FEEDBACK_CLOSED,
)

export default UserFeedbackClosedAnalytics
